import clsx from 'clsx';
import { isNil } from 'ramda';
import { Link } from 'react-router-dom';

import { UseIcons } from 'src/models/interface.model';
import { UseIcon } from 'src/components/UseIcon';
import { CONFIG } from 'src/config';
import { ifTrue } from 'src/tools/logic.tools';

import classes from './IconBadge.module.scss';

interface Props {
  iconId?: UseIcons;
  className?: string;
  title?: string;
  onClick?: () => void;
  isSmall?: boolean;
  to?: string;
  count?: number;
}

// new-ui
export function IconBadge({ className, iconId = 'info-fill', onClick, title, isSmall, to, count }: Props) {
  function renderIcon() {
    return <UseIcon iconId={iconId} />;
  }

  function renderCount() {
    const displayCount = count && count > CONFIG.maxIconBadgeCount ? '9+' : count?.toString();

    return <div className={clsx(classes['count-icon'], { [classes.small]: isSmall })}>{displayCount}</div>;
  }

  const button = (
    <button
      data-testid='icon-badge'
      className={clsx(classes.container, 'row centered', className, { [classes.small]: isSmall })}
      onClick={onClick}
      title={title}
    >
      {ifTrue(!isNil(count), renderCount, renderIcon)}
    </button>
  );

  return to ? (
    <Link to={to} rel='noopener noreferrer'>
      {button}
    </Link>
  ) : (
    button
  );
}
